<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" class="icon icon-close-small">
    <polygon
      points="0.874 7.833 4 4.707 7.126 7.833 7.833 7.126 4.707 4 7.833 0.874 7.126 0.167 4 3.293 0.874 0.167 0.167 0.874 3.293 4 0.167 7.126 0.874 7.833"
      fill="#515151" />
  </svg>
</template>

<script>
export default {
  name: 'IconClose'
}
</script>
